<div class="flex mt1 ml1 py2">
  <div class="mr-1">
    <app-element-select displayLabel='Search By'
                        [defaultValue]="searchByOptions[0]"
                        [options]="searchByOptions"
                        (selectionChanged)="onSearchBySelectionChanged($event)">
    </app-element-select>
  </div>
  <div class="ml3">
    <mat-form-field class="w-90">
      <mat-label>Search for External Drugs</mat-label>
      <input matInput type='text'
             data-qa="qa-input-search"
             [formControl]="searchValueFormControl"
             (input)="onInputChangedSearchCase($any($event.target).value)">
    </mat-form-field>
  </div>
</div>

<div *ngIf="dataSource" class="mat-elevation-z8 table-container">
  
  <!--Mat Table-->
  <table mat-table [dataSource]="dataSource">
    
    <ng-container [matColumnDef]="tableColumns.NappiCode">
      <th *matHeaderCellDef mat-header-cell> Nappi Code</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.NappiCode]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.Name">
      <th *matHeaderCellDef mat-header-cell> Name</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.Name]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.DrugSchedule">
      <th *matHeaderCellDef mat-header-cell> Drug Schedule</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.DrugSchedule]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.AtcLevel5Code">
      <th *matHeaderCellDef mat-header-cell> ATC Level 5 Code</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.AtcLevel5Code]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.StandardPacksize">
      <th *matHeaderCellDef mat-header-cell> Pack Size</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.StandardPacksize]}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.SingleExitPrice">
      <th *matHeaderCellDef mat-header-cell> SEP excl. VAT</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.SingleExitPrice]?.toFixed(2)}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.SingleExitPriceIncVAT">
      <th *matHeaderCellDef mat-header-cell> SEP incl. VAT</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.SingleExitPriceIncVAT]?.toFixed(2)}}</td>
    </ng-container>
    
    <ng-container [matColumnDef]="tableColumns.UnitPriceIncVAT">
      <th *matHeaderCellDef mat-header-cell> Unit Price incl. VAT</th>
      <td *matCellDef="let row" mat-cell> {{row[tableColumns.UnitPriceIncVAT]?.toFixed(2)}}</td>
    </ng-container>
    
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <mat-paginator [length]="length"
                 [pageSize]="pageSize"
                 [pageIndex]="0"
                 [pageSizeOptions]="pageSizeOptions">
  </mat-paginator>
  
</div>
